import React from 'react';
import {redirectToSamlLogin} from 'components/routes/Router.utils';
import {LOGIN_REDIRECT_PARAM} from '@components/login/LoginConstants';

export interface SamlStepProps {
  samlName: string | null;
  tenantId: string | null;
}

export const SamlStep: React.FC<SamlStepProps> = props => {
  const searchParams = new URLSearchParams(window.location.search);
  const redirectPath = searchParams.get(LOGIN_REDIRECT_PARAM);
  redirectToSamlLogin(redirectPath, props.samlName ?? 'mediafly', props.tenantId);
  return <></>;
};
